import { Component } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-store-notification-bar',
  templateUrl: './store-notification-bar.component.html',
  styleUrls: ['./store-notification-bar.component.scss']
})
export class StoreNotificationBarComponent {

  system_notifications: any;
  env = environment;

  constructor(private http: HttpClient) { }
  

  ngOnInit() {
    this.http.get(`${this.env.assessment_admin}api/v1/public/system_settings.json`).subscribe(data => {
        this.system_notifications = data;
        console.log(this.system_notifications[0]);
      }, error => {
        console.log(error);
      });
  }

}
